import { FaceMonocleIcon } from "@icons/FaceMonocleIcon";
import {
    FallbackButton,
    FallbackContainer,
    FallbackText,
} from "./CommentsFallback.styles";
import React from "react";

export const CommentsFallback = ({
    onCommentButtonClick,
}: {
    onCommentButtonClick: () => void;
}) => {
    return (
        <FallbackContainer>
            <FaceMonocleIcon
                height="64px"
                width="64px"
                fill="var(--community-color-primary-text)"
            />
            <FallbackText>
                Noch ruhig hier! Schreibe den ersten Kommentar.
            </FallbackText>
            <FallbackButton onClick={onCommentButtonClick}>
                <span>Kommentieren</span>
            </FallbackButton>
        </FallbackContainer>
    );
};
